import {useParams} from "react-router-dom";
import styles from "./PPTInsertWaitingPage.module.css";
import Lottie from "react-lottie";
import {
    POLL_SHARE_MODE,
    POLL_TYPE,
    PPT_CACHED_INSERTING_ACTIVITY_NAME,
    PPT_RUNNING_APP_TYPE,
} from "../../utils/constants";
import { useTranslation } from "react-i18next";
import React, {useEffect, useState} from "react";
import addingSlidesGoogleSlides from "./animations/addingSlides_GoogleSlides.json";
import addingSlidesPowerPoint from "./animations/addingSlides_PowerPoint.json";
import addingSlidesKeynote from "./animations/addingSlides_Keynote.json";
import openApp from "./animations/open_one_application.json";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import {notifyError} from "../../utils/helpers";
import YuJaButton from "../../components/standardization/YuJaButton";
import {ReactComponent as BACK} from "../../images/arrow-left-purple.svg"
import {ReactComponent as RELEASE_ICON} from "./images/choose_app.svg";
import {ReactComponent as KEYNOTE_AND_PPT} from "./images/keynote_and_powerpoint_img.svg";
import {usePPTWebView} from "../../hooks/usePPTWebView";
import KEYNOTE_ICON from "./images/keynote_icon.png";
import POWERPOINT_ICON from "./images/powerpoint_icon.png";



export default function PPTInsertWaitingNewPage() {
    const { t } = useTranslation();
    const { runningApp } = useParams();
    const [setRunningApp, ] = useLocalStorageNew("PPT_RUNNING_APP", "");
    const [setInsertedSlides, ] = useLocalStorageNew("PPT_INSERTED_SLIDES", 2);
    const [, getInsertingActivity ] = useLocalStorageNew(PPT_CACHED_INSERTING_ACTIVITY_NAME, {});
    const {postPresentationSlides, checkAppRunning} = ReportApiCalls();
    const [isProcessing, setIsProcessing] = useState(false);
    const [isSelectedAppInserting, setIsSelectedAppInserting] = useState(false);
    const [selectedApp, setSelectedApp] = useState("");
    let {goPollsPage} = usePPTWebView();
    const { pollType=POLL_TYPE.MERGED_POLL, } = getInsertingActivity();

    const NONE_OPTION = {
        loop: false,
        autoplay: true,
        animationData: openApp,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    }

    const GOOGLE_SLIDES_OPTION = {
        loop: true,
        autoplay: true,
        animationData: addingSlidesGoogleSlides,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };

    const POWERPOINT_OPTION = {
        loop: true,
        autoplay: true,
        animationData: addingSlidesPowerPoint,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };

    const KEYNOTE_OPTION = {
        loop: true,
        autoplay: true,
        animationData: addingSlidesKeynote,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice",
        }
    };

    const setInsertedSlidesCount = async () => {
        const {shareMode, pollType=POLL_TYPE.MERGED_POLL, totalQuestions=1} = getInsertingActivity();

        try {
            if (pollType === POLL_TYPE.ATTENDANCE || shareMode !== POLL_SHARE_MODE.SHARE_EACH) {
                setInsertedSlides(2);
            } else {
                setInsertedSlides(1 + totalQuestions);
            }
        } catch (e) {
            console.log("Error in fetching poll data to set inserted slides count:", e);
        }

    }

    useEffect(() => {
        setRunningApp(runningApp);
        if (runningApp === PPT_RUNNING_APP_TYPE.NONE || runningApp === PPT_RUNNING_APP_TYPE.BOTH) {
            return;
        }

        const {pollKey="", pollCode="", shareMode} = getInsertingActivity();

        setInsertedSlidesCount().then(() => {
            postPresentationSlides(pollKey, pollCode,  shareMode, runningApp).then();
        });
    }, []);



    if (!!isSelectedAppInserting
        || runningApp === PPT_RUNNING_APP_TYPE.POWERPOINT
        || runningApp === PPT_RUNNING_APP_TYPE.KEYNOTE
        || runningApp === PPT_RUNNING_APP_TYPE.GOOGLE_SLIDES
    ) {
        return (
            <div className={styles.container}>
                <div style={{flex: 1}}/>
                {(runningApp === PPT_RUNNING_APP_TYPE.POWERPOINT || selectedApp === PPT_RUNNING_APP_TYPE.POWERPOINT) &&
                    <Lottie
                        options={POWERPOINT_OPTION}
                        height={260}
                        width={260}
                        isClickToPauseDisabled={true}
                        style={{cursor: "default"}}
                    />
                }

                {(runningApp === PPT_RUNNING_APP_TYPE.GOOGLE_SLIDES || selectedApp === PPT_RUNNING_APP_TYPE.GOOGLE_SLIDES) &&
                    <Lottie
                        options={GOOGLE_SLIDES_OPTION}
                        height={260}
                        width={260}
                        isClickToPauseDisabled={true}
                        style={{cursor: "default"}}
                    />
                }

                {(runningApp === PPT_RUNNING_APP_TYPE.KEYNOTE || selectedApp === PPT_RUNNING_APP_TYPE.KEYNOTE) &&
                    <Lottie
                        options={KEYNOTE_OPTION}
                        height={260}
                        width={260}
                        isClickToPauseDisabled={true}
                        style={{cursor: "default"}}
                    />
                }
                <span className={styles.title}>
                    {pollType === POLL_TYPE.ATTENDANCE ? t("poll.insertingYourAttendance") : t("poll.insertingYourPoll")}

                </span>
                <div style={{height: 20}}/>
                <span className={styles.description}>
                {pollType === POLL_TYPE.ATTENDANCE
                    ? t("poll.insertingYourAttendanceDescription")
                    : t("poll.insertingYourPollDescription")
                }
            </span>
                <div style={{flex: 3}}/>
            </div>
        );
    }


    if (runningApp === PPT_RUNNING_APP_TYPE.BOTH) {
        return (
            <div className={styles.container}>
                <span
                    tabIndex={0}
                    style={{
                        cursor: "pointer",
                        alignSelf: "start",
                        display: "flex", alignItems: "center",
                        height: 60, padding: 15,
                        outlineOffset: -2,
                    }}
                    onClick={() => goPollsPage()}
                >
                    <BACK style={{marginRight: 2}}/>
                    <span>{t("poll.pptCompletePageGoBackButtonText")}</span>
                </span>

                <div style={{flex: 1}}/>
                <div
                    className={styles.row}
                    style={{
                        alignSelf: "center",
                        gap: 15,
                        maxWidth: 720,
                        margin: "0 20px",
                    }}
                >
                    <span className={styles.plusIconWrapper}><RELEASE_ICON style={{width: 32, height: 32}}/></span>
                   <span className={styles.title} style={{fontSize: 15, padding: "0 20px"}}>
                        {t("integration.pptChooseApp")}
                    </span>

                </div>
                <div style={{height: 40}}/>

                <div style={{ width: "100%", display: "flex", gap: 40, padding: "0 20px", justifyContent: "center", flexWrap: "wrap"}}>
                    <div
                        tabIndex={0}
                        role={"button"}
                        className={`${styles.applicationCard} ${selectedApp === PPT_RUNNING_APP_TYPE.POWERPOINT ? styles.active : ""}`}
                        onClick={() => {
                            const {pollKey = "", pollCode = "", shareMode} = getInsertingActivity();
                            setInsertedSlidesCount().then(() => {
                                postPresentationSlides(pollKey, pollCode,  shareMode, PPT_RUNNING_APP_TYPE.POWERPOINT).then();
                            });
                            setSelectedApp(PPT_RUNNING_APP_TYPE.POWERPOINT);
                            setIsSelectedAppInserting(true);
                        }}
                    >
                        <div style={{flex: 1}}/>
                        <img src={POWERPOINT_ICON} alt="PowerPoint" style={{maxWidth: 128, width: "80%", height: "auto"}} />

                        {/*<RELEASE_ENTIRELY_IMAGE style={{marginBottom: 15, flexShrink: 0, height: 80}}/>*/}
                        <span className={styles.title}
                              style={{textAlign: "center", fontSize: 16, marginTop: 10}}>{"PowerPoint"}</span>
                        <div style={{flex: 1}}/>
                    </div>

                    <div
                        tabIndex={0}
                        role={"button"}
                        className={`${styles.applicationCard} ${selectedApp === PPT_RUNNING_APP_TYPE.KEYNOTE ? styles.active : ""}`}
                        onClick={() => {
                            const {pollKey = "", pollCode = "", shareMode} = getInsertingActivity();
                            setInsertedSlidesCount().then(() => {
                                postPresentationSlides(pollKey, pollCode,  shareMode, PPT_RUNNING_APP_TYPE.KEYNOTE).then();
                            });
                            setSelectedApp(PPT_RUNNING_APP_TYPE.KEYNOTE);
                            setIsSelectedAppInserting(true);
                        }}
                    >
                        <div style={{flex: 1}}/>
                        <img src={KEYNOTE_ICON} alt="Keynote" style={{maxWidth: 128, width: "80%", height: "auto"}}/>
                        <span className={styles.title} style={{textAlign: "center", fontSize: 16, marginTop: 10}}>{"Keynote"}</span>
                        <div style={{flex: 1}}/>
                    </div>
                </div>

                <div style={{flex: 2}}/>
                {/*<div className={styles.footer}>*/}
                {/*    <YuJaButton*/}
                {/*        disabled={!selectedApp || isProcessing}*/}
                {/*        style={{padding: "5px 10px", width: 130}}*/}
                {/*        onClick={() => {*/}
                {/*            const {pollKey = "", pollCode = "", shareMode} = getInsertingActivity();*/}
                {/*            postPresentationSlides(pollKey, pollCode, shareMode, selectedApp).then(() => {*/}

                {/*            });*/}
                {/*            setIsSelectedAppInserting(true);*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        {INSERT_HEADER}*/}
                {/*    </YuJaButton>*/}
                {/*</div>*/}
            </div>
        );
    }


    if (runningApp === PPT_RUNNING_APP_TYPE.NONE) {
        return (
            <div className={styles.container}>
                <span
                    tabIndex={0}
                    style={{
                        cursor: "pointer",
                        alignSelf: "start",
                        display: "flex", alignItems: "center",
                        height: 60, padding: 15,
                        outlineOffset: -2,
                    }}
                    onClick={() => goPollsPage()}
                >
                    <BACK style={{marginRight: 2}}/>
                    <span>{t("poll.pptCompletePageGoBackButtonText")}</span>
                </span>

                <div style={{flex: 1}}/>

                <div style={{position: "relative"}}>
                    <Lottie
                        options={NONE_OPTION}
                        height={260}
                        width={260}
                        isClickToPauseDisabled={true}
                        style={{cursor: "default"}}
                    />
                    <KEYNOTE_AND_PPT style={{position: "absolute", top: 59, left: 59, width: 141}}/>
                </div>



                {/*<div*/}
                {/*    style={{*/}
                {/*        display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column",*/}
                {/*        gap: 20, width: 500, height: 300, borderRadius: 16, color: "#FFF", background: "#000",*/}
                {/*        fontSize: 28, fontWeight: "600", marginBottom: 30,*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <span>Video Placeholder</span>*/}
                {/*    <span>Sandro will provide the video</span>*/}
                {/*</div>*/}
                {/*<div className={classes.waitingIllustrationWrapper} style={{width: 190, height: 190, marginBottom: 40}}>
                    <img
                        src={PollIsClosedIllustration}
                        alt="waiting"
                        style={{
                            width: 120,
                            height: 120,
                            flexShrink: 0,
                        }}
                    />


                </div>*/}
                <span className={styles.title}>
                    {t("poll.pptOpenPptOrKeynote")}

                </span>
                <div style={{height: 20}}/>
                <span className={styles.description} style={{padding: "0 20px", textAlign: "center"}}>
                    {pollType === POLL_TYPE.ATTENDANCE
                        ? t("poll.pptOpenPptOrKeynoteDescriptionAttendance")
                        : t("poll.pptOpenPptOrKeynoteDescriptionPoll")
                    }
                </span>
                <div style={{height: 40}}/>
                <YuJaButton
                    style={{minWidth: 140, height: 36}}
                    disabled={isProcessing}
                    onClick={() => {
                        const {pollKey = "", pollCode = "", shareMode, totalQuestions} = getInsertingActivity();
                        setIsProcessing(true);
                        checkAppRunning(pollKey, pollCode, shareMode, pollType, totalQuestions).catch(err => {
                            console.log(err);
                            notifyError(t("report.insertSlideError", {
                                activityType: pollType === POLL_TYPE.ATTENDANCE ? t("poll.attendanceLabel") : t("poll.mergedModeText")
                            }));
                            setIsProcessing(false);
                        });
                    }}
                >
                    {t("poll.insertActivityText", {
                        activityType: pollType === POLL_TYPE.ATTENDANCE ? t("poll.attendanceLabel") : t("poll.mergedModeText")
                    })}

                </YuJaButton>
                <div style={{flex: 2}}/>
            </div>
        );
    }


    return (
        <></>
    );
}